import React from 'react';

import { MenuItem } from '@material-ui/core';

import { UiButton } from '../../ui/ui-button';
import { UiKebabMenu } from '../../ui/ui-kebab-menu';

import {
  statusDisplay,
  SAVED_STATUS,
  REJECTED_STATUS,
  EMPLOYED_STATUS,
} from '../../config/application-status-config';
import { formatPhoneNumber } from '../../util/formatters';

type InputProps = {
  applicant: FullApplicant;
  accountHasMultipleOrgs: boolean;
  openProfile: () => void;
  messageApplicant: () => void;
  shareApplicant: () => void;
  moveApplicant: () => void;
  viewInFlow: () => void;
  gridContainerClass: string;
  screenSizes: {
    isXSmallScreen: boolean;
    isSmallScreen: boolean;
    isMediumScreen: boolean;
  };
};

export const ApplicantDirectoryCard = ({
  applicant,
  accountHasMultipleOrgs,
  openProfile,
  messageApplicant,
  moveApplicant,
  shareApplicant,
  viewInFlow,
  gridContainerClass,
  screenSizes: { isXSmallScreen, isSmallScreen, isMediumScreen },
}: InputProps) => {
  const displayStatus = statusDisplay(applicant.status);
  const formattedPhoneNumber = formatPhoneNumber(applicant.phoneNumber);
  const collapseButton = isMediumScreen || isXSmallScreen;

  const handleMessage = (e: React.MouseEvent<HTMLElement, MouseEvent>) => {
    e.stopPropagation();
    messageApplicant();
  };

  return (
    <div
      role="presentation"
      onClick={openProfile}
      className="u-padding-lg u-border-top u-hover-highlight u-cursor-pointer"
      key={`applicant-directory-${applicant.job_applicant_id}`}
    >
      <div className={gridContainerClass}>
        {isSmallScreen ? (
          <div className="typo-title u-display-flex u-flexDirection-column u-justifyContent-center u-alignItems-flexStart">
            {applicant.firstName} {applicant.lastName}
            <div>{formattedPhoneNumber}</div>
          </div>
        ) : (
          <>
            <div className="typo-title u-flex-center">{applicant.firstName}</div>

            <div className="typo-title u-flex-center">{applicant.lastName}</div>

            <div className="typo-title u-flex-center">{formattedPhoneNumber}</div>
          </>
        )}

        {!isSmallScreen && accountHasMultipleOrgs && (
          <div className="typo-title u-flex-center">{applicant.orgName}</div>
        )}

        <div className="typo-title u-display-flex u-flexDirection-column u-justifyContent-center u-alignItems-flexStart">
          {applicant.jobTitle}{' '}
          {isSmallScreen &&
            (accountHasMultipleOrgs ? (
              <div>({applicant.orgName})</div>
            ) : (
              <div>({applicant.jobLocation})</div>
            ))}
        </div>

        {!isSmallScreen && !accountHasMultipleOrgs && (
          <div className="typo-title u-flex-center">{applicant.jobLocation}</div>
        )}
        {!isXSmallScreen && <div className="typo-title u-flex-center">{displayStatus}</div>}
        {!isSmallScreen && (
          <div>
            {applicant.status === SAVED_STATUS && applicant.savedReason && (
              <div className="typo-title u-flex-center">{applicant.savedReason}</div>
            )}
            {applicant.status === REJECTED_STATUS && applicant.rejectionReason && (
              <div className="typo-title u-flex-center">{applicant.rejectionReason}</div>
            )}
          </div>
        )}
        <div
          className={`u-flex-center u-justifyContent-flexEnd u-flexWrap-nowrap ${
            collapseButton ? '' : 'u-width-125px'
          }`}
        >
          {!collapseButton && (
            <UiButton
              variant="tertiary"
              onClick={handleMessage}
              size={isSmallScreen ? 'xs' : 'sm'}
              className="u-zIndex-100 u-padding-x u-height-fitContent"
            >
              Message
            </UiButton>
          )}
          <UiKebabMenu
            menuId="applicantDirectoryMoreOptionsMenu"
            className="u-zIndex-100 u-padding-xs"
            stopPropagation
          >
            {collapseButton && <MenuItem onClick={handleMessage}>Message Applicant</MenuItem>}
            <MenuItem onClick={openProfile}>View Profile</MenuItem>
            <MenuItem onClick={moveApplicant}>Move Applicant</MenuItem>
            <MenuItem onClick={shareApplicant}>Share Applicant</MenuItem>
            {applicant.status !== EMPLOYED_STATUS && (
              <MenuItem onClick={viewInFlow}>View in Job Flow</MenuItem>
            )}
          </UiKebabMenu>
        </div>
      </div>
    </div>
  );
};
